import { Injectable, inject } from '@angular/core';
import { TitleStrategy, RouterStateSnapshot } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { CLIENT_DATA, ClientData } from '@frontend/util-api-data';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly translate = inject(TranslateService);

  private readonly clientTitle: string;

  constructor() {
    const clientData = inject<ClientData>(CLIENT_DATA);

    super();
    switch (clientData.name) {
      case 'jansen':
        this.clientTitle = 'Jansen Docu Center';
        break;
      case 'aks':
        this.clientTitle = 'AKS TechDocWeb';
        break;
      default:
        this.clientTitle = 'Schüco Docu Center';
    }
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    // Routes with a categoryId param are handled by BreadcrumbComponent
    if (routerState.url.includes('/categories/')) return;

    const titleKey = this.buildTitle(routerState);
    if (titleKey) {
      const translated = this.translate.instant(titleKey);
      this.title.setTitle(translated !== titleKey ? translated : titleKey);
    } else {
      this.title.setTitle(this.clientTitle);
    }
  }
}
